import { TransformPlainObject } from './transform.plainObject';
import { ConditionExpressionPlainObject } from './conditionExpression.plainObject';

export class MultiInputStreamBasePlainObject extends TransformPlainObject {
    public conditionExpressions: ConditionExpressionPlainObject[] = [];
}
